<template>
    <v-list dense>
        <!-- <v-subheader>My Details</v-subheader> -->
        <v-list-item>
            <!-- :to="{
                name: 'ParentDetail',
                params: { person: parent, personId: parentPersonId }
            }" -->

            <v-list-item-avatar color="primary" style="justify-content: center">
                <img
                        v-if="parent.photoUrl"
                        :src="parent.photoUrl"
                        :alt="`${initials} Avatar`"
                />

                <span v-else class="white--text headline">{{ initials }}</span>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title>
                    {{ parent.firstName }}
                    {{ parent.lastName }}
                </v-list-item-title>
            </v-list-item-content>

            <!-- 			<v-list-item-action>
                <v-btn icon ripple>
                    <v-icon color="UIAction" style="font-size: 16px"
                        >fal fa-chevron-right</v-icon
                    >
                </v-btn>
            </v-list-item-action> -->
        </v-list-item>
    </v-list>
</template>

<script>
import Avatar from './Avatar';

export default {
  data() {
    return {};
  },

  computed: {
    parent() {
      return this.$store.getters.parent;
    },
    initials() {
      if (this.parent.firstName && this.parent.lastName) {
        return (
          this.parent.firstName[0].toUpperCase()
                        + this.parent.lastName[0].toUpperCase()
        );
      }
    },
    parentPersonId() {
      if (this.parent.personId) {
        return this.parent.personId;
      }
      return 'null';
    },
  },

  components: {
    Avatar,
  },

  created() {
  },
};
</script>

<style scoped>
    h4 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 4px;
    }

    h5 {
        font-size: 1.3rem;
        text-align: center;
    }

    .parent .avatar {
        display: grid;
        text-align: center;
        align-items: center;
        grid-row-gap: 4px;
    }
</style>
